import axiosInstance from "../service/api_service.js";
import ApiRoutes from "../utils/api_routes.js";

export const login = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.login, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getProfile = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.profile, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const updateProfile = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.updateProfile, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};
export const getEmployeeBirthDay = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.employeeBirthDay, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};
